import styled from "styled-components"
import { desktopTextStyles, FontFamilyRegular } from "./typography.styles"
import Breakpoints from "./breakpoints"

export const SubHeading = styled.p`
  ${desktopTextStyles.HeadingFourBold}
  color: var(--burnt-orange);
  grid-column: 3 / 11;
  width: 100%;
  text-align: center;
  margin-top: 44px;

  @media (min-width: ${Breakpoints.md}) {
    margin-top: 64px;
  }
  @media (min-width: ${Breakpoints.lg}) {
    margin-top: 96px;
  }
`
export const Title = styled.h2`
  ${desktopTextStyles.HeadingOneRegular}
  color: #17191D;
  grid-column: 2 / 12;
  width: 100%;
  text-align: center;
  margin-top: 14px;
  margin-bottom: 30px;

  @media (min-width: ${Breakpoints.md}) {
    margin-bottom: 62px;
  }
`
export const Disclaimer = styled.p`
  display: block;
  ${desktopTextStyles.FooterBodyTextSmall}
  line-height: 160%;
  opacity: 0.5;

  width: 100%;
  text-align: center;
  margin-bottom: 48px;
  grid-column: 3 / 11;
  margin-top: 27px;

  @media (min-width: ${Breakpoints.lg}) {
    grid-column: 4 / 10;
  }
`

export const StartConversationButton = styled.button`
  display: flex;
  justify-content: center;
  ${FontFamilyRegular}
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 14px;
  letter-spacing: 0.2em;
  text-transform: uppercase;
  background-color: var(--burnt-orange);
  color: var(--white);
  padding: 16px 32px;
  border: none;
  outline: none;
  justify-self: center;
  align-self: center;
  grid-column: 3 / 11;
  grid-row: 3;
  margin-bottom: 46px;

  @media (min-width: ${Breakpoints.md}) {
    display: none;
  }
`
